import React, { useState , useEffect } from 'react';
import { useNavigate , useLocation } from 'react-router-dom';

import { Button } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ForumIcon from '@mui/icons-material/Forum';
import EventIcon from '@mui/icons-material/Event';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import HelpIcon from '@mui/icons-material/Help';
import ArrowbackSharp from '@mui/icons-material/ArrowBackSharp';
import Styles from "../../../Styles/sidebar.module.css"
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';



const Sidebar = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(localStorage.getItem('activeTab') || '');

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    localStorage.setItem('activeTab', tabName);
    navigate(`/${tabName}`);
  };

  useEffect(() => {
    setActiveTab(localStorage.getItem('activeTab') || '');
  }, [location.pathname]);



  return (
    
    <div id={Styles.sidebar} 
     >
    <div className={Styles.menu} >
      <div
        className={activeTab === '' ? Styles.active : ""}
        onClick={() => handleTabClick("")}
        id={Styles.link}
        style={{ cursor:"pointer" , boxShadow: "0px 12.3352px 37.0056px rgba(136, 51, 255, 0.1)"}}
      >
        <HomeIcon  className={ Styles.icon}  />
        <p>Home</p>
      </div>
      <div
        to="/jobs"
        className={location.pathname.includes('jobs') ? Styles.active : ""}
        onClick={() =>  handleTabClick('jobs')}
        id={Styles.link}
        style={{ cursor:"pointer" , boxShadow:"0px 2.46704px 6.16761px rgba(38, 51, 77, 0.03)"}}
      >
       <ForumIcon   className={ Styles.icon}  /> 
        <p>My Jobs</p>
      </div>
      <div
        to="/edit"
        className={location.pathname.includes('edit') ? Styles.active : ""}
        onClick={() => handleTabClick('edit')}
        id={Styles.link} 
        style={{ cursor:"pointer", boxShadow:"0px 2.46704px 6.16761px rgba(38, 51, 77, 0.03)" }}
      >
        <EventIcon  className={ Styles.icon}   />
       <p>Submmitted Applications</p>
      </div>
      <div
        to="/resume"
        className={location.pathname.includes('resume') ? Styles.active : ""}
        onClick={() => handleTabClick('resume')}
        id={Styles.link} 
        style={{ cursor:"pointer" , boxShadow:"0px 2.46704px 6.16761px rgba(38, 51, 77, 0.03)"}}
      >
        <CloudDownloadIcon  className={ Styles.icon}  />
       <p>Manage Resume</p>
       <ArrowForwardIos  className={ Styles.Homeicon}    sx={{ width:"16.67px",height:"16.67px" , position:"relative", top:"6.8px" ,left:"50px"}} />
      </div>
      <div
        to="/interview"
        className={location.pathname.includes('interview') ? Styles.active : ""}
        onClick={() => handleTabClick('interview')}
        id={Styles.link}
        style={{ cursor:"pointer", boxShadow:"0px 2.46704px 6.16761px rgba(38, 51, 77, 0.03)", }}
      >
        <ChatBubbleIcon  className={ Styles.icon}  />
       <p>Interviews</p>
      </div>
      <div
        to="/skill"
        className={location.pathname.includes('skill') ? Styles.active : ""}
        onClick={() => handleTabClick('skill')}
        id={Styles.link} 
        style={{ cursor:"pointer" , boxShadow:"0px 2.46704px 6.16761px rgba(38, 51, 77, 0.03)"}}
      >
        <HelpIcon  className={ Styles.icon} />
       <p> Skill Center</p>
      </div> 

      <div   
         id={Styles.logout}
        
      >
      <Button
      to="/skill"
      id={Styles.logoutbtn}
      className={location.pathname.includes('skill') ? Styles.active : ""}
        onClick={() => handleTabClick('skill')}
     
     >  
     <p>Logout</p>
     <ArrowbackSharp  className={ Styles.arrowicon} />
     </Button>
     </div>
    </div>
    </div>
  );
}

export default Sidebar;
